// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"05f81e0c","767":"e823892d","979":"d57d411e"}[chunkId] + ".chunk.css";
};